module.exports = __webpack_public_path__ + "img/36.7a3f45fd.png";